// import '@comfama/comfama-ui-react/style_important.css';
import "./src/styles/global.css"
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from "react";
import { AuthProvider } from "./src/utils/hooks/AuthManager";

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
);